import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failureGetScheduleSetupData,
    successGetScheduleSetupData,
    ScheduleSetupPayload
} from "./ScheduleSetupDataSlice";

// API call to fetch schedule setup data
const GetScheduleSetupDataApi = (payload: ScheduleSetupPayload) => {
    const { subject_id, start_time, end_time } = payload;
    return api.get(`/api/schedule-class/setup-data?subject_id=${subject_id}&start_time=${start_time}&end_time=${end_time}`);
};

// Saga to handle fetching schedule setup data
export function* ScheduleSetupDataCall(action: PayloadAction<ScheduleSetupPayload>) {
    try {
        const response: AxiosResponse = yield call(GetScheduleSetupDataApi, action.payload);
        if (response.data.status) {
            yield put(successGetScheduleSetupData(response.data));
        } else {
            yield put(failureGetScheduleSetupData(response.data.message));
        }
    } catch (error: any) {
        yield put(failureGetScheduleSetupData(error.response?.data || error.message));
    }
}
